/** Formats a COP amount compactly: $0, $450, $12K, $1.20MM. Under a thousand it
 *  is the amount itself — rounded to thousands, $450 read "$0K". */
export function formatCOP(value: number): string {
  if (!value || value <= 0) return '$0';
  if (value < 1_000) return `$${Math.round(value).toLocaleString('es-CO')}`;
  const mm = value / 1_000_000;
  if (mm < 1) return `$${Math.round(value / 1_000).toLocaleString('es-CO')}K`;
  const dec = mm < 10 ? 2 : 1;
  return `$${mm.toLocaleString('es-CO', { minimumFractionDigits: dec, maximumFractionDigits: dec })}MM`;
}
